import { DbMongoSerializationBaseInfos } from "./db-mongo-serialization-base-infos";
import { ManualTaskPlanningStatus } from "./manual-task-planning-status";
import { DbObjectCreateOrUpdateInfos } from "./db-object-create-or-update-infos";
import { DbManualTaskPlanningStatusHistoryInfos } from "./db-manual-task-planning-status-history-infos";
import { CurrencyPriceInfos } from "./currency-price-infos";
import { PlanningTaskType } from "./planning-task-type";

export class DbOrderManualTaskPlanningInfos extends DbMongoSerializationBaseInfos {
  platformId: number | null = 0;
  objectId: number | null = 0;
  sort: number | null = 0;
  status: ManualTaskPlanningStatus | null = null;
  name: string | null = null;
  userId: number | null = 0;
  taskId: number | null = 0;
  serviceId: number | null = 0;
  orderItemId: number | null = 0;
  creationInfos: DbObjectCreateOrUpdateInfos | null = null;
  completeInfos: DbObjectCreateOrUpdateInfos | null = null;
  statusHistory: DbManualTaskPlanningStatusHistoryInfos[] | null = [];
  prices: CurrencyPriceInfos[] | null = [];
  objectName: string | null = null;
  titleName: string | null = null;
  serviceName: string | null = null;
  taskName: string | null = null;
  taskErpCode: string | null = null;
  customerName: string | null = null;
  userName: string | null = "Unknown";
  activitiesCount: number = 0;
  events: ManualTaskPlanningEventInfos[] | null = null;
  orderItemColor: string | null = null;
  orderDueDate: Date | null = null;
  type: PlanningTaskType | null = null;
  mpDuration: number | null = null;
  tags: ManualTaskPlanningTag[] | null = null;

  constructor(init?: Partial<DbOrderManualTaskPlanningInfos>) {
    super();
    Object.assign(this, init);
  }
}

export interface ManualTaskPlanningEventInfos {
  guid: string;
  name: string | null;
  spentTime: string | null;
  allDay: boolean;
  assignInfos: DbObjectCreateOrUpdateInfos | null;
  claimInfos: DbObjectCreateOrUpdateInfos | null;
  resourceIds: number[] | null;
  dueDateElapsed: boolean;
  comment: string | null;
}

export enum TaskTag {
  EpNb = "EpNb",
  SubtitleVersion = "SubtitleVersion",
}

export interface ManualTaskPlanningTag {
  tag: TaskTag;
  value: string;
}
